(function($) {

  var $btnSearch = $('.site-header .navbar .btn-search');
  var $btnExit = $('.site-header .exit');
  var $searchBar = $('.site-header .search-bar');
  var $input = $searchBar.find('input');

  $btnSearch.click(function(e) {
    e.preventDefault();
    $searchBar.toggleClass('active');
    $btnSearch.toggleClass('active');
    $input.focus();
  });

  $btnExit.click(function(e) {
    e.preventDefault();
    $searchBar.removeClass('active');
    $btnSearch.removeClass('active');
    $input.blur();
  });

})(jQuery);